const TRACK_EVENT_TYPE = Object.freeze({
  upgradeSmsSettings: 'Upgrade_SMS_Settings',
  enableDacSettings: 'Enable_DAC_Settings',
  enabledReminders: 'Enabled_reminders',
  enabledBoltOn: 'Enabled_bolt_on',
  marketingTab: 'click_marketing_tab',
  clientsTab: 'click_clients_tab',
  campaignsTab: 'click_campaigns_tab',
  autoTab: 'click_auto_tab',
  remindersTab: 'click_reminders',
  viewChangeHistory: 'view_underscore_change_history',
});

// noinspection JSUnusedGlobalSymbols
export default TRACK_EVENT_TYPE;
